import { AxiosResponse } from 'axios';
import { create, METHOD } from '../utils'

// 声明一个类型
export declare type TableType = "thtt_organization_scope" | "thtt_showroom_stage" | "thtt_showroom" | "thtt_showroom_item" | "thtt_showroom_item_content" | "thtt_meeting_process" | "thtt_setting" | "thtt_news" | "thtt_meeting" | "thtt_organization_group_item" | "thtt_organization_group" | "thtt_competition" | "thtt_competition_user" | "thtt_feedback" | "thtt_push_wechat" | "thtt_push_wechat_items" | "thtt_push_wechat_orgs" | "thtt_comment" | "thtt_user" | "thtt_attachment_relation" | "thtt_cloud_params" | "thtt_scope" | "thtt_user_state" | "thtt_clinic" | "thtt_course" | "thtt_course_user" | "thtt_project"  |"thtt_project_rec_opinion"| "thtt_project_recommend" | "thtt_course_chapter" | "thtt_video" | "thtt_chengguo" | "thtt_chengguo_scope" | "thtt_xuqiu" | "thtt_xuqiu_scope" | "thtt_organization_user" | "thtt_organization" | "thtt_forum_cooperation" | "thtt_forum_campaign" | "thtt_clinic_result";
export type ServerResponse<R = any> = {
    msg: string,
    result: R,
    status: 200 | unknown
}
export type Where = object | Array<object | "AND" | "OR">;
export type LeftJoin = {
    table: string,
    on: string,
    columns?: string[],
}
export type Process = {
    name: string,
    key: string,
    targetKey: string,
    params: {
        table: string,
        where?: object,
        columns?: string
        order?: string[]
    }
}

export default {

    work: (props: object[]): AxiosResponse<ServerResponse> => create({
        url: "/egg/base/work",
        method: METHOD.POST
    })(props),

    /** 查询列表 */
    list: <T>(props: {
        table: TableType,
        columns?: [],
        where?: Where,
        leftJoin?: LeftJoin[] | LeftJoin,
        pageIndex?: number,
        pageSize?: number,
        order?: string[],
        process?: Process
    }): AxiosResponse<ServerResponse<T>> => create({
        url: "/egg/base/list",
        method: METHOD.GET
    })(props),

    /** */
    adds: (props: {
        table: TableType,
        data: string
    }): AxiosResponse<ServerResponse> => create({
        url: "/egg/base/adds",
        method: METHOD.POST
    })(props),

    /** */
    add: <R>(props: {
        table: TableType,
        data: object
    }): AxiosResponse<ServerResponse<R>> => create({
        url: "/egg/base/add",
        method: METHOD.POST
    })(props),

    put: (props: {
        table: TableType,
        data: object,
        where: Where
    }): AxiosResponse<ServerResponse> => create({
        url: "/egg/base/put",
        method: METHOD.PUT
    })(props),

    del: (props: {
        table: TableType,
        where: Where
    }): AxiosResponse<ServerResponse> => create({
        url: "/egg/base/del",
        method: METHOD.DELETE
    })(props),

    remove: (props: {
        table: TableType,
        where: Where
    }): AxiosResponse<ServerResponse> => create({
        url: "/egg/base/remove",
        method: METHOD.DELETE
    })(props),
}